import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const FlagIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M14.456.132c-2.588 1.319-3.822.877-5.146.403C8.04.08 6.687-.404 3.975.61A16 16 0 0 0 3 1.013V12q.524-.259 1-.443.525-.202 1-.324c1.86-.48 3.18-.104 4.501.27 1.634.464 3.268.928 5.92-.225a.98.98 0 0 0 .579-.9V.963c0-.785-.838-1.19-1.544-.831M14 9.688V2.514c-.978.358-1.867.511-2.722.49-1.097-.028-2-.354-2.618-.577l-.156-.056c-.644-.23-1.094-.364-1.69-.36-.425.004-1.004.083-1.814.356v6.815a8.7 8.7 0 0 1 1.584-.174c1.325-.021 2.426.279 3.286.521l.115.033c.843.238 1.423.402 2.088.433.512.025 1.127-.032 1.927-.307M2 1a.999.999 0 1 0-2 0v14.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
FlagIcon.id = 'FlagIcon';
FlagIcon.displayName = 'FlagIcon';
export default FlagIcon;
